// Content.jsx
import styled from 'styled-components';

const ContentWrapper = styled.div`
    padding: 5%;
    background-color: #f4f4f4;
    max-width: 1200px; /* Ограничиваем максимальную ширину контента */
    margin: 0 auto; /* Центрируем контент */
`;

export default ContentWrapper;